import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  border: 0;\n  border-radius: 3px;\n  cursor: pointer;\n  display: inline-block;\n  overflow: hidden;\n  padding: 14px 30px 15px 30px;\n  position: relative;\n  text-align: center;\n  vertical-align: top;\n  white-space: nowrap;\n  user-select: none;\n  opacity: 1;\n  margin: 0;\n  background: transparent;\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: 1;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);\n\n\n  ", " {\n  }\n\n  ", " {\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n    ", "\n  \n  ", "\n\n  ", "\n\n  ", "\n  \n    ", "\n  \n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: top;\n  line-height: 130%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { Fragment } from "react";
import styled from "styled-components";
import { typography, colorLibrary } from "../../shared/styles";
import IconSpinner from "../../shared/icons/icon-spinner";
var Text = styled.span(_templateObject());
var Loading = styled.span(_templateObject2());
var APPEARANCES = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  TERTIARY: "tertiary",
  TERTIARY_NEUTRAL: "tertiaryNeutral"
};
var SIZES = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
};
var StyledButton = styled.button(_templateObject3(), typography.weight.black, typography.size.small, Text, Loading, function (props) {
  return props.disabled && "\n      cursor: not-allowed !important;\n      opacity: 0.2;\n      &:hover {\n      }\n      &:active {\n      }\n    ";
}, function (props) {
  return props.isUnclickable && "\n      cursor: default !important;\n      pointer-events: none;\n      &:hover {\n      }\n    ";
}, function (props) {
  return props.isLoading && "\n      cursor: progress !important;\n\n      ".concat(Loading, " {\n        opacity: 1;\n      }\n\n      ").concat(Text, " {\n        opacity: 0;\n      }\n\n      &:hover {\n      }\n    ");
}, function (props) {
  return props.containsIcon && "\n      svg {\n        display: block;\n        margin: 0;\n      }\n      padding: ".concat(props.size === SIZES.SMALL ? "7" : "12", "px;\n    ");
}, function (props) {
  return props.size === SIZES.SMALL && "\n    padding: 12px 30px;\n    ";
}, function (props) {
  return props.size === SIZES.LARGE && "\n      padding: 30px 30px 29px 30px;\n      ";
}, function (props) {
  return props.appearance === APPEARANCES.PRIMARY && "\n      background: ".concat(colorLibrary.blues.brandBlue, ";    \n      color: ").concat(colorLibrary.neutrals.white, ";\n      border: 2px solid ").concat(colorLibrary.blues.brandBlue, ";\n      &:hover {\n        background: ").concat(colorLibrary.blues.hoverBlue, ";\n        border: 2px solid ").concat(colorLibrary.blues.hoverBlue, ";\n        box-shadow: 0px 2px 20px rgba(3, 155, 232, 0.5);\n      }\n      &:focus {\n        border: 2px solid ").concat(colorLibrary.blues.coolBlue, ";\n        box-shadow: 0px 2px 20px rgba(3, 155, 232, 0.5);\n      }\n      &:focus:hover {\n        border: 2px solid ").concat(colorLibrary.blues.coolBlue, ";\n        background: ").concat(colorLibrary.blues.hoverBlue, ";\n        box-shadow: 0px 2px 20px rgba(3, 155, 232, 0.5);\n        \n      }\n      &:active {\n        box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.3);\n        background: ").concat(colorLibrary.blues.hoverBlue, ";\n        \n        border: 2px solid ").concat(colorLibrary.blues.brandBlue, ";\n      }\n      &:active:focus {\n        border: 2px solid ").concat(colorLibrary.blues.coolBlue, ";\n        box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.3);\n        background: ").concat(colorLibrary.blues.hoverBlue, ";\n      }\n      ").concat(props.disabled && "\n        &:hover {\n          background: ".concat(colorLibrary.blues.brandBlue, ";\n          border: 2px solid ").concat(colorLibrary.blues.brandBlue, ";\n          box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);\n\n        }\n        "), "\n    \n    ");
}, function (props) {
  return props.appearance === APPEARANCES.SECONDARY && "\n      background: ".concat(colorLibrary.neutrals.white, ";\n      color: ").concat(colorLibrary.primary.brandBlue, ";\n      border: 1px solid ").concat(colorLibrary.primary.brandBlue, ";\n      &:hover {\n        border: 2px solid ").concat(colorLibrary.blues.hoverBlue, ";\n        color: ").concat(colorLibrary.blues.hoverBlue, ";\n      }\n      &:focus {\n        border: 2px solid ").concat(colorLibrary.blues.coolBlue, ";\n        color: ").concat(colorLibrary.blues.hoverBlue, ";\n      }\n      &:active {\n        color: ").concat(colorLibrary.blues.hoverBlue, ";\n        border: 1px solid ").concat(colorLibrary.blues.brandBlue, ";\n        box-sizing: border-box;\n        box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.3);\n      }\n\n      ").concat(props.disabled && "\n        &:hover {\n          border: 1px solid ".concat(colorLibrary.primary.brandBlue, ";\n          color: ").concat(colorLibrary.primary.brandBlue, ";\n        }\n        "), "\n\n\n    ");
}, function (props) {
  return props.appearance === APPEARANCES.TERTIARY && "\n      background: transparent;\n      padding: 0px;\n      color: ".concat(colorLibrary.blues.brandBlue, ";\n      box-shadow: none;\n      letter-spacing: 0.8px;\n      line-height: 130%;\n      border: 2px solid transparent;\n\n      ").concat(Text, " {\n        &:hover {\n          text-decoration: underline;\n        }\n        &:focus {\n          text-decoration: underline;\n        }\n        &:active {\n          text-decoration: underline;\n        }\n\n      }\n    \n\n      &:hover {\n        color: ").concat(colorLibrary.blues.hoverBlue, ";\n      }\n      &:active {\n        opacity: 1;\n      }\n      &:focus {\n        opacity: 1;\n\n      }\n      &:focus:hover {\n        opacity: 1;\n      }\n      ").concat(props.disabled && "\n        opacity: 0.5;\n        ".concat(Text, " {\n            text-decoration: underline;\n        }\n        &:hover {\n          color: ").concat(colorLibrary.blues.brandBlue, ";\n\n        }\n        &:focus {\n\n        }\n        &:focus:hover {\n        }\n        &:active {\n          opacity: 0.5;\n        }\n        }\n  \n      "), "\n    ");
}, function (props) {
  return props.appearance === APPEARANCES.TERTIARY_NEUTRAL && "\n        background: transparent;\n        padding: 0px;\n        color: ".concat(colorLibrary.neutrals.darkGray, ";\n        box-shadow: none;\n        opacity: 0.75;\n        letter-spacing: 0.8px;\n        line-height: 130%;\n        border: 2px solid transparent;\n\n        &:hover {\n          opacity: 1;\n        }\n        &:active {\n          opacity: 1;\n          text-decoration: underline;\n        }\n        &:focus {\n          opacity: 1;\n          border: 2px solid ").concat(colorLibrary.neutrals.darkGray, ";\n  \n        }\n        &:focus:hover {\n          opacity: 1;\n          border: 2px solid ").concat(colorLibrary.neutrals.darkGray, ";\n  \n        }\n        ").concat(props.disabled && "\n          opacity: 0.5;\n          &:hover {\n            opacity: 0.5;\n          }\n          &:focus {\n  \n          }\n          &:focus:hover {\n          }\n        ", "\n  \n      ");
}); // const ButtonLink = StyledButton.withComponent("a");
// const applyStyle = (ButtonWrapper) => {
//   return (
//     ButtonWrapper &&
//     StyledButton.withComponent(
//       ({ containsIcon, isLoading, isUnclickable, ...rest }) => (
//         <ButtonWrapper {...rest} />
//       )
//     )
//   );
// };

/**
- Use a Button for allowing base level user interactivity.
**/

export function Button(_ref) {
  var isDisabled = _ref.isDisabled,
      isLoading = _ref.isLoading,
      loadingText = _ref.loadingText,
      isLink = _ref.isLink,
      children = _ref.children,
      ButtonWrapper = _ref.ButtonWrapper,
      props = _objectWithoutProperties(_ref, ["isDisabled", "isLoading", "loadingText", "isLink", "children", "ButtonWrapper"]);

  var spinnerFillColor = colorLibrary.blues.brandBlue;

  switch (props.appearance) {
    case APPEARANCES.PRIMARY:
      spinnerFillColor = colorLibrary.neutrals.white;
      break;

    case APPEARANCES.TERTIARY_NEUTRAL:
      spinnerFillColor = colorLibrary.neutrals.darkGray;
      break;

    default:
      spinnerFillColor = colorLibrary.blues.brandBlue;
      break;
  }

  var buttonInner = /*#__PURE__*/React.createElement(Fragment, null, !isLoading && /*#__PURE__*/React.createElement(Text, null, children), isLoading && /*#__PURE__*/React.createElement(Loading, null, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 20,
      height: 20,
      marginRight: 6
    }
  }, /*#__PURE__*/React.createElement(IconSpinner, {
    fill: spinnerFillColor
  })), /*#__PURE__*/React.createElement("span", null, loadingText || "Loading..."))); // const StyledButtonWrapper = () =>
  //   React.useMemo(() => applyStyle(ButtonWrapper), [ButtonWrapper]);
  // const StyledButtonWrapper = () => applyStyle(ButtonWrapper);
  // let SelectedButton = StyledButton;
  // if (ButtonWrapper) {
  //   SelectedButton = StyledButtonWrapper;
  // } else if (isLink) {
  //   SelectedButton = ButtonLink;
  // }

  return /*#__PURE__*/React.createElement(StyledButton, Object.assign({
    isLoading: isLoading,
    disabled: isDisabled
  }, props), buttonInner);
}
Button.defaultProps = {
  isLoading: false,
  loadingText: null,
  isLink: false,
  appearance: APPEARANCES.PRIMARY,
  isDisabled: false,
  isUnclickable: false,
  containsIcon: false,
  size: SIZES.MEDIUM
};